import { AppNS } from 'app';
import { addCacheItemInInfiniteResults, updateCacheItemProp } from 'app/core/cache/helpers';
import { WebsocketMessage } from 'app/types';
import { useEffect } from 'react';

import { useQueryClient } from '@tanstack/react-query';

export interface TicketCommentCreatedProps {
  message: WebsocketMessage;
}

export default function TicketCommentCreated(props: TicketCommentCreatedProps) {
  const { message } = props;

  const queryClient = useQueryClient();

  useEffect(() => {
    if (!message.model || message?.model?.error) {
    } else {
      if (message.model.ticket) {
        updateCacheItemProp<AppNS.Ticket>(queryClient, ['ticket-details', message.model.id], {
          state: message.model.state,
        });
      }

      console.log('TicketCommentCreated', message.model.ticket_comment);

      if (message.model.ticket_comment) {
        addCacheItemInInfiniteResults<AppNS.TicketComment>(
          queryClient,
          ['ticket', message.model.id, 'comments'],
          message.model.ticket_comment as AppNS.TicketComment
        );
      }
    }
  }, [message.uuid]);

  return null;
}
